import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1185.45929,0.0338823529 L1185.45929,564.739765 L1750.16518,564.739765 L1750.16518,1920.03388 L168.988706,1920.03388 L168.988706,0.0338823529 L1185.45929,0.0338823529 Z M900.508706,677.680941 C883.680471,677.680941 868.546353,685.248 857.591059,698.688 C807.784,758.659765 826.193412,891.704471 838.842824,970.763294 C841.666353,988.720941 839.294588,1006.90447 831.614588,1023.28094 L831.614588,1023.28094 L723.755765,1256.50447 C715.849882,1273.44565 703.200471,1287.11153 687.162824,1296.03388 C619.059294,1333.86918 504.875765,1385.70918 491.096941,1478.65976 C486.127529,1508.928 496.179294,1535.01741 519.671059,1558.50918 C535.595765,1573.64329 554.908706,1581.21035 575.915765,1581.21035 C657.346353,1581.21035 708.734588,1509.49271 764.188706,1432.69271 C788.809882,1398.47153 825.854588,1377.46447 866.626353,1371.81741 C942.974588,1361.31388 1034.45694,1339.29035 1089.79812,1324.83388 C1117.69459,1317.49271 1146.15576,1319.29976 1173.60047,1327.99624 C1222.16518,1343.58212 1240.57459,1353.06918 1296.36753,1353.06918 C1346.73929,1353.06918 1381.18635,1341.32329 1397.90165,1318.62212 C1411.34165,1301.79388 1414.61694,1279.09271 1408.06635,1253.00329 C1396.20753,1210.19859 1406.03341,1163.328 1275.02165,1163.328 C1245.65694,1163.328 1217.08282,1166.15153 1193.25224,1169.42682 C1156.43341,1174.39624 1119.95341,1158.47153 1096.23576,1128.54212 C1063.93459,1087.99624 1031.06871,1040.10918 1008.25459,1005.32329 C992.104,980.815059 986.682824,951.337412 991.991059,922.198588 C1007.464,837.492706 1010.40047,774.584471 968.499294,715.516235 C950.880471,690.330353 927.275765,677.680941 900.508706,677.680941 Z M1298.41176,16.8734118 L1733.34824,451.809882 L1298.41176,451.809882 L1298.41176,16.8734118 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M791.057412,1297.94259 C883.330353,1254.57318 1066.97271,1232.66259 1066.97271,1232.66259 C974.586824,1143.66494 921.052706,1017.62259 921.052706,1017.62259 C877.796235,1144.22965 801.335059,1281.90494 791.057412,1297.94259"
}));

var IconPdfSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconPdfSolid, _Component);

  var _super = _createSuper(IconPdfSolid);

  function IconPdfSolid() {
    _classCallCheck(this, IconPdfSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconPdfSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPdf",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPdfSolid.displayName = "IconPdfSolid";
  return IconPdfSolid;
}(Component);

IconPdfSolid.glyphName = 'pdf';
IconPdfSolid.variant = 'Solid';
IconPdfSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPdfSolid;
export { IconPdfSolid };